module.exports = __webpack_public_path__ + "img/bg_function02_2_d.3a2efc43.png";